import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", href: "/" },
  { label: "实用工具", href: "/category/tools" },
  { label: "设计素材", href: "/category/design" },
  { label: "技术文章", href: "/category/tech" },
  { label: "学习资源", href: "/category/learning" },
  { label: "效率提升", href: "/category/productivity" },
  { label: "精品推荐", href: "/category/recommended" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="text-xl font-bold text-foreground-900 tracking-tight whitespace-nowrap">
              91精选
            </span>
            <span className="hidden sm:inline-block text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
              精品内容聚合
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "text-foreground-700 hover:text-foreground-900 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 bg-background-50 border-t border-background-200/70">
            {navItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`block px-4 py-3 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
    </header>
  );
}